import { render, staticRenderFns } from "./DocumentsContractorProjects.vue?vue&type=template&id=deadac9a"
import script from "./DocumentsContractorProjects.vue?vue&type=script&lang=ts"
export * from "./DocumentsContractorProjects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deadac9a')) {
      api.createRecord('deadac9a', component.options)
    } else {
      api.reload('deadac9a', component.options)
    }
    module.hot.accept("./DocumentsContractorProjects.vue?vue&type=template&id=deadac9a", function () {
      api.rerender('deadac9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resources/DocumentsContractorProjects.vue"
export default component.exports